/*
  New since the last visit (Johannes, 2026-10-09). Nothing here moves what is on screen (page speed, CLS):
  - The visits are counted by a tiny inline script in layout/theme.liquid on every page (last page view and
    the visit before; a new visit after 12 hours). First visits see nothing of this.
  - Tiles in collection grids (li[data-ikn-created], sections/main-collection.liquid) added after the visit
    before get a small "New" in the brand line (inside the existing line, no new line).
  - New Arrivals (ul[data-ikn-issues]): the issue rows come from Liquid. Here only: a repeated row where
    "More products" adds the next page is removed, and "You're all caught up" is put where the new pieces
    end, but only while that place is below the screen, so nothing visible jumps (waits for scrolling).
  - Homepage cover ([data-ikn-since], sections/ik-home-cover.liquid): Liquid writes "New this week: …";
    for returning visitors the words become "Since your last visit: …" in the same reserved space.
  No requests, no counters on icons. Texts come from the page (Liquid, DE/EN). Styles: assets/ik-next.css.
*/
(() => {
  // seconds of the visit before, set by the small inline script in layout/theme.liquid (0 = first visit)
  const since = window.iknSince || 0;
  if (!since) return;
  const lang = document.documentElement.lang || 'en';

  // "New" on tiles
  const markNew = (scope) => {
    scope.querySelectorAll('li[data-ikn-created]:not([data-ikn-checked])').forEach((li) => {
      li.setAttribute('data-ikn-checked', '');
      if (Number(li.dataset.iknCreated) <= since) return;
      const list = li.closest('[data-ikn-new-label]');
      const brand = li.querySelector('p.text-scheme-secondary');
      if (!list || !brand || brand.querySelector('.ikn-new')) return;
      const tag = document.createElement('span');
      tag.className = 'ikn-new';
      tag.textContent = list.dataset.iknNewLabel;
      brand.classList.add('ikn-has-new');
      brand.appendChild(tag);
    });
  };

  // New Arrivals: drop an issue row that repeats the one before (where a page was added)
  const tidy = (list) => {
    let prev = '';
    list.querySelectorAll(':scope > .ikn-issue').forEach((row) => {
      if (row.dataset.iknWeek === prev) row.remove();
      else prev = row.dataset.iknWeek;
    });
  };

  // "You're all caught up" before the first piece from before the last visit, only while off screen
  const caught = (list) => {
    if (list.querySelector(':scope > .ikn-caught')) return true;
    const items = [...list.children].filter((li) => li.dataset.iknCreated);
    const i = items.findIndex((li) => Number(li.dataset.iknCreated) <= since);
    if (i < 0) return false; // the end of the new pieces is not loaded yet
    if (i === 0) return true; // nothing new: no row
    let at = items[i];
    const before = at.previousElementSibling;
    if (before && before.classList.contains('ikn-issue')) at = before;
    // only below the screen: nothing visible moves (iPhones have no scroll anchoring for rows put in above)
    if (at.getBoundingClientRect().top < window.innerHeight) return false;
    const c = document.createElement('li');
    c.className = 'ikn-caught';
    const b = document.createElement('b');
    b.textContent = list.dataset.iknCaught;
    const s = document.createElement('span');
    const day = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', timeZone: 'Europe/Berlin' }).format(new Date(since * 1000));
    s.textContent = list.dataset.iknCaughtNote.replace('{date}', day);
    c.append(b, s);
    at.before(c);
    return true;
  };

  const run = () => {
    markNew(document);

    document.querySelectorAll('ul[data-ikn-issues]').forEach((list) => {
      let done = caught(list);
      let ticking = false;
      const check = () => {
        if (done || ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          done = caught(list);
          if (done) window.removeEventListener('scroll', check);
        });
      };
      if (!done) window.addEventListener('scroll', check, { passive: true });
      new MutationObserver(() => {
        markNew(list);
        tidy(list);
        if (!done) check();
      }).observe(list, { childList: true });
    });

    // other grids that get more tiles later ("More products")
    document.querySelectorAll('ul[data-ikn-new-label]:not([data-ikn-issues])').forEach((list) => {
      new MutationObserver(() => markNew(list)).observe(list, { childList: true });
    });

    // homepage cover: same place, other words
    const box = document.querySelector('[data-ikn-since]');
    if (box) {
      let data = {};
      try {
        data = JSON.parse(box.querySelector('script').textContent) || {};
      } catch (e) {
        data = {};
      }
      const all = data.p || [];
      const p = all.filter((t) => t > since).length;
      const s = (data.s || []).filter((t) => t > since).length;
      if (p || s) {
        const ds = box.dataset;
        const bits = [];
        if (p) bits.push(p >= 50 ? ds.tMany : p === 1 ? ds.tPiece : ds.tPieces.replace('{n}', p));
        if (s) bits.push(s === 1 ? ds.tStory : ds.tStories.replace('{n}', s));
        box.querySelector('[data-ikn-since-text]').textContent = ds.tLead + ' ' + bits.join(', ');
      }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
